// extracted by mini-css-extract-plugin
export default {"capabilityItemWrapper":"styles_capabilityItemWrapper__1yA0w","rightPos":"styles_rightPos__NGfr8"};